export default __webpack_public_path__ + "static/wordcloud-c15a1918fc0d26485ea3394ddb123cc6.webp";